module.exports = __webpack_public_path__ + "static/media/follow-icon.e36a9c35.png";